import { AccessToken, Configuration } from './sdk-v1';

export const apiConfig = (forceToken?: string) => {
  if (forceToken) {
    return new Configuration({
      basePath: import.meta.env.VITE_API_BASE_URL || 'http://localhost:9001',
      accessToken: forceToken,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${forceToken}`,
        'X-API-Key': `0d7f4b1b-0d7f-4b1b-9d0f-8b0f3f7c6f2a`,
      },
    });
  }

  const accessTokenString = localStorage.getItem('accessToken');
  // console.log('accessTokenString', accessTokenString);
  const accessToken: AccessToken = accessTokenString
    ? JSON.parse(accessTokenString)
    : undefined;
  // console.log('accessToken', accessToken);
  return new Configuration({
    basePath: import.meta.env.VITE_API_BASE_URL || 'http://localhost:9001',
    accessToken: accessToken?.id ?? undefined,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${accessToken?.id}`,
      'X-API-Key': `0d7f4b1b-0d7f-4b1b-9d0f-8b0f3f7c6f2a`,
    },
  });
};
